import React, { useState } from 'react';
import { getDomainConfig } from '../config';
import './FAQPage.css';

function FAQPage() {
  const config = getDomainConfig();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: `What products does ${config.name} offer?`,
      answer: `${config.name} specializes in ${config.tagline.toLowerCase()}. We offer an extensive catalog of products from verified suppliers and manufacturers across the industry.`
    },
    {
      question: 'How do I place an order?',
      answer: 'Browse our catalog, find the products you need, and contact the supplier directly or use our inquiry form. Our team can also assist you in finding the right products for your specific needs.'
    },
    {
      question: 'Do you ship internationally?',
      answer: 'Shipping options vary by supplier. Many of our suppliers offer international shipping. Contact the specific supplier or our support team for detailed shipping information.'
    },
    {
      question: 'How can I get pricing information?',
      answer: 'Pricing is available for most products on their detail pages. For custom quotes or bulk orders, please contact the supplier directly or reach out to our sales team.'
    },
    {
      question: 'Are your suppliers verified?',
      answer: 'Yes, all suppliers on our platform are carefully vetted to ensure they meet our quality and reliability standards.'
    },
    {
      question: 'Can I request a custom product?',
      answer: 'Many of our suppliers offer custom manufacturing and fabrication services. Contact us with your specifications, and we\'ll connect you with the right supplier.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'Payment methods vary by supplier but typically include wire transfer, credit cards, and purchase orders for qualified businesses.'
    },
    {
      question: 'How long does shipping take?',
      answer: 'Shipping times depend on the product, supplier location, and your delivery address. Typical lead times range from a few days to several weeks for custom orders.'
    },
    {
      question: 'Do you offer bulk discounts?',
      answer: 'Yes, many suppliers offer volume discounts. Contact the supplier or our sales team with your quantity requirements for a custom quote.'
    },
    {
      question: 'What is your return policy?',
      answer: 'Return policies vary by supplier and product type. Please review the specific supplier\'s policy or contact our customer support for assistance.'
    },
    {
      question: 'How can I track my order?',
      answer: 'Once your order ships, you\'ll receive tracking information from the supplier. You can also contact customer support for order status updates.'
    },
    {
      question: 'Do you provide technical support?',
      answer: 'Yes, our team and suppliers can provide technical assistance to help you select the right products and answer any technical questions.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="faq-hero">
        <h1>Frequently Asked Questions</h1>
        <p>Find answers to common questions about {config.name}</p>
      </div>

      <div className="faq-content">
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-contact">
          <h2>Still Have Questions?</h2>
          <p>Can't find the answer you're looking for? Our team is here to help.</p>
          <a href="/contact" className="contact-button">Contact Us</a>
        </div>
      </div>
    </div>
  );
}

export default FAQPage;
